export const decodeName = (name = '') => {
  try {
    return decodeURIComponent(name);
  } catch (err) {
    console.debug(err);
    return name;
  }
};
